export const MECHANIC_APP_SALES_REP = 17;

export const MECHANIC_SKU_PRICE_TIERING_TYPE = Object.freeze({
  EXACT_QUANTITY: "EXACT",
  RANGE: "RANGE",
});
